export * from './trip-display.component';
